import script from "./relSeguro.vue?vue&type=script&setup=true&lang=ts"
export * from "./relSeguro.vue?vue&type=script&setup=true&lang=ts"

import "./relSeguro.vue?vue&type=style&index=0&id=749e0a7e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-749e0a7e"]])

export default __exports__